import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../utils/util";
import LanguageSelector from '../LanguageSelector';
import { getClinicId, getClinicLogoUrl, getClinicName, getClinicTagLine, isWhiteLabelEnabled } from '../../utils/config';

const HeaderComponent = ({ logged_in, user, account, logout }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const linksRef = useRef(null);

  const isWhiteLabel = isWhiteLabelEnabled();
  const logoUrl = getClinicLogoUrl(user);
  const clinicName = getClinicName();
  const clinicTagLine = getClinicTagLine();
  const clinicId = getClinicId(user);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    
  // const tabName = (user.role === "AD" || user.role === "CA" || user.role === "DO" || user.role === "CO") 
  //   ? t("tabs.team") 
  //   : t("tabs.doctors");

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleClickOutside = useCallback((event) => {
    if (!event.target.closest('.custom-main-header')) {
      closeMenu();
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      closeMenu(); // (already closing menu on resize which is good!)
    };
  
    window.addEventListener('resize', handleResize);
    window.addEventListener('click', handleClickOutside);
  
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);
  
  // useEffect(() => {
  //   window.addEventListener('resize', closeMenu);
  //   window.addEventListener('click', handleClickOutside);

  //   return () => {
  //     window.removeEventListener('resize', closeMenu);
  //     window.removeEventListener('click', handleClickOutside);
  //   };
  // }, [handleClickOutside]);

  const mapUserRole = (role, t) => {
    return t(`roles.${role}`, t("roles.default"));
   } 
   
  return (
    <header className="custom-main-header">
      {/*Logo Section */}
      {(logged_in || isWhiteLabel) ? (
        <div className="custom-logo-container-branded">
          {logoUrl ? (
            <>
              <img
                src={logoUrl}
                alt="Clinic Logo"
                className="custom-clinic-logo"
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
              />
              {clinicName && clinicTagLine && (
                <div className="clinic-details" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
                  <div className="clinic-name-header">{clinicName}</div>
                  <div className="clinic-tagline-header">{clinicTagLine}</div>
                </div>
              )}
            </>
          ) : (
            <div className="clinic-details" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
              <div className="clinic-name-header" style={{ color: 'var(--clr-accent)' }}>{clinicName}</div>
            </div>
          )}
        </div>
      ) : (
        <div className="custom-logo-container-normal">
          <a href="/" className="custom-logo-normal">
            <img 
              // src="/images/logos/PlusLife-Logo-4.svg"
              src = "/images/logos/PlusLife-Logo-Primary-Filled.svg"
              alt="Logo"
              className="custom-logo-img"
            />
            <div className="custom-logo-text-container">
              <div className="logo-name">PlusLife</div>
              <div className="logo-tagline">Nourish your body, mind and soul</div>
            </div>
          </a>
        </div>
      )}

      {/* Navigation Section */}
      <nav className={`custom-nav-links ${isMenuOpen ? 'open' : ''}`}>
        {!logged_in ? (
          <>
            <LanguageSelector />
            <ul className="custom-links" ref={linksRef} onClick={closeMenu}>
              {isWhiteLabel ? (
                <>
                  <li className={location.pathname === "/register" ? "active-tab" : ""}>
                  <Link to="/register" className="nav-tooltip-wrapper nav-tooltip-bottom-left">
                    <span>{t("header.patient_signup")}</span>
                    <div className="nav-tooltip-text">{t("header.tooltip_patient_signup")}</div>
                  </Link>
                  </li>

                <li className="signin-popup" style={{ marginRight: '5rem' }}>
                  <span className="nav-tooltip-wrapper nav-tooltip-bottom-right" onClick={() => account(1)}>
                    {t("header.login")}
                    <div className="nav-tooltip-text">{t("header.tooltip_login_all_roles")}</div>
                  </span>
                </li>
                </>
              ) : (
                <>
                  <li className={location.pathname === "/about" ? "active-tab" : ""}>
                    <Link to="/about"><span>{t("header.about_us")}</span></Link>
                  </li>
                   <li className={location.pathname === "/clinic-pricing" ? "active-tab" : ""}>
                    <Link to="/clinic-pricing"><span>{t("header.pricing")}</span></Link>
                  </li>
                  <li className={location.pathname === "/contact" ? "active-tab" : ""}>
                    <Link to="/contact"><span>{t("header.contact_us")}</span></Link>
                  </li>
                  <li className={location.pathname === "/register" ? "active-tab" : ""}>
                    <Link to="/register"><span>{t("header.signup")}</span></Link>
                  </li>
                  {/* <li className="signin-popup" onClick={() => account(1)}>
                    <span>{t("header.login")}</span>
                  </li> */}
                </>
              )}
            </ul>
          </>
        ) : (
          <>
            <LanguageSelector />
            <ul className="custom-links" ref={linksRef} onClick={closeMenu}>

              {user?.role === "PA" && (
                <>
                {/* <li className={location.pathname === `/scheduling/${user.patient_id}` ? "active-tab" : ""}>
                  <Link to={`/scheduling/${user.patient_id}`}>
                    <span>{t("header.patient_dashboard")}</span>
                  </Link>
                </li> */}

                <li className={location.pathname === "/customer-scheduling" ? "active-tab" : ""}>
                  <Link to="/customer-scheduling">
                    <span>{t("header.patient_dashboard")}</span>
                  </Link>
                </li>
                
                <li className={location.pathname === "/health-history" ? "active-tab" : ""}>
                  <Link to="/health-history">
                    <span>{t("header.intake_form")}</span>
                  </Link>
                </li>

                <li className={location.pathname === "/patient-appointments" ? "active-tab" : ""}>
                  <Link to="/patient-appointments">
                    <span>{t("header.bookings")}</span>
                  </Link>
                </li>
                </>
              )}

              {user?.role === "DO" && user?.doctor_id && (
                <li className={location.pathname === `/practitioner-dashboard/${user.doctor_id}` ? "active-tab" : ""}>
                  <Link to={`/practitioner-dashboard/${user.doctor_id}`}>
                    <span>{t("header.practitioner_dashboard")}</span>
                  </Link>
                </li>
              )}

              {(user.role === "CO" || user.role === "CA") && (
                <>
                  <li className={location.pathname === "/manage-cards" ? "active-tab" : ""}>
                    <Link to="/manage-cards"><span>{t("header.payments")}</span></Link>
                  </li>

                  <li className={location.pathname === "/configure-availability" ? "active-tab" : ""}>
                    <Link to="/configure-availability"><span>{t("header.configure")}</span></Link>
                  </li>

                </>
              )}
              {(user.role === "CO") && (
              <li className={location.pathname === "/manage-staff" ? "active-tab" : ""}>
                    <Link to="/manage-staff">
                      <span>{t("header.manage_staff").replace(' ', '\u00A0')}</span> {/* 👈 non-breaking space */}
                    </Link>
                  </li>
              )}

              {(user.role === "CO" || user.role === "CA") && (
                <li className={location.pathname === "/quick-patient-signup" ? "active-tab" : ""}>
                  <Link to="/quick-patient-signup">
                    <span>{t("header.quick_add")}</span>
                  </Link>
                </li>
              )}

              {(user?.role === "CA" || user?.role === "CO") && clinicId && (
                <>
                <li className={location.pathname === "/admin-scheduling" ? "active-tab" : ""}>
                <Link to="/admin-scheduling"><span>{t("header.scheduling")}</span></Link>
                </li>
                <li className={location.pathname === `/admin-dashboard/${user.role}/${clinicId}` ? "active-tab" : ""}>
                  <Link to={`/admin-dashboard/${user.role}/${clinicId}`}>
                    <span>{t("header.admin_dashboard")}</span>
                  </Link>
                </li>
                </>
              )}

              {/* {( user.role === "PA") && (
                <li className={location.pathname === "/practitioners" ? "active-tab" : ""}>
                  <Link to="/practitioners"><span>{tabName}</span></Link>
                </li>
              )} */}

              {/* {(user?.role === "CO" || user?.role === "CA")  && (
                <li className={`${location.pathname === "/communication-console" ? "active-tab" : ""}`}>
                  <Link to={`/communication-console`}>
                    <span>{t("header.conversations")}</span>
                  </Link>
                </li>
              )}
              {(user?.role === "CO" || user?.role === "CA")  && (
                <li className={`${location.pathname === "/clinic-settings" ? "active-tab" : ""}`}>
                  <Link to={`/clinic-settings`}>
                    <span>{t("header.settings")}</span>
                  </Link>
                </li>
              )} */}

            {/* Features Dropdown or Direct Tabs Start */}
              {(user?.role === "CO" || user?.role === "CA") && (
                <>
                  {isMobile ? (
                    <>
                      {/* On Mobile - Show as separate tabs */}
                      <li className={location.pathname === "/reports" ? "active-tab" : ""}>
                        <Link to="/reports">
                          <span>{t("header.reports")}</span>
                        </Link>
                      </li>
                      <li className={location.pathname === "/communication-console" ? "active-tab" : ""}>
                        <Link to="/communication-console">
                          <span>{t("header.conversations")}</span>
                        </Link>
                      </li>
                      <li className={location.pathname === "/clinic-settings" ? "active-tab" : ""}>
                        <Link to="/clinic-settings">
                          <span>{t("header.settings")}</span>
                        </Link>
                      </li>
                      <li className={location.pathname.startsWith("/configurations") ? "active-tab" : ""}>
                      <Link to="/configurations/manage-slots">
                        <span>{t("header.configurations").replace(" ", "\u00A0")}</span>
                      </Link>
                      </li>
                    </>
                  ) : (
                    <>
                      {/* On Desktop - Group under Features Dropdown */}
                      <li className="features-dropdown">
                        <span className="features-dropbtn">
                          {t("header.more")}
                          <span 
                            className="dropdown-caret"
                            style={{
                              marginLeft: '0.25rem',
                              fontSize: '0.55rem',
                              lineHeight: '1',
                              display: 'inline-block',
                              position: 'relative',
                              top: '2px' 
                            }}
                          >
                            ▼
                          </span>
                        </span>
                        <div className="features-dropdown-content">
                          <Link to="/reports">{t("header.reports")}</Link> 
                          <Link to="/communication-console">{t("header.conversations")}</Link>
                          <Link to="/clinic-settings">{t("header.settings")}</Link>
                          <Link to="/configurations/manage-slots">
                            <span>{t("header.configurations").replace(" ", "\u00A0")}</span>
                          </Link>
                        </div>
                      </li>
                    </>
                  )}
                </>
              )}
            {/* Features Dropdown or Direct Tabs End */}

              <li className={location.pathname === "/profile" ? "active-tab" : ""}>
                <Link to="/profile">
                  <span className="user-info">
                    <span className="user-role-badge" style={{fontSize:'0.85rem', fontWeight:'500',}}>{mapUserRole(user.role, t)}</span>
                    <span className="user-name" style={{color:'var(--blue-light)'}}>{capitalizeFirstLetter(user.first_name)}</span>
                  </span>
                </Link>
              </li>
              <li>
                <span onClick={() => { logout(); navigate("/"); }} className="btn">{t("header.logout")}</span>
              </li>
            </ul>
          </>
        )}
      </nav>

      <div className="custom-hamburger-menu" onClick={toggleMenu}>
        <span className="custom-hamburger-icon"></span>
        <span className="custom-hamburger-icon"></span>
        <span className="custom-hamburger-icon"></span>
      </div>
    </header>
  );
};

export default HeaderComponent;
